import React from "react";
import { Link } from "react-router-dom";
import { usePlans } from "../hooks/usePlans";
import { formatInrFromPaise } from "../utils/validation";
import "../styles/saas.css";

export default function PlanComparisonPage() {
  const { plans, loading } = usePlans();

  return (
    <div className="saas-page">
      <header className="saas-header">
        <Link to="/" className="saas-logo">Beentara</Link>
        <nav><Link to="/pricing">Pricing</Link><Link to="/login">Login</Link></nav>
      </header>
      <h1>Compare plans</h1>
      {loading ? (
        <p>Loading…</p>
      ) : (
        <table className="saas-compare-table">
          <thead>
            <tr>
              <th>Feature</th>
              {plans.map((p) => <th key={p.id}>{p.name}</th>)}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Monthly</td>
              {plans.map((p) => <td key={p.id}>{formatInrFromPaise(p.monthly_price_paise)}</td>)}
            </tr>
            <tr>
              <td>Yearly</td>
              {plans.map((p) => <td key={p.id}>{formatInrFromPaise(p.yearly_price_paise)}</td>)}
            </tr>
            <tr>
              <td>Users</td>
              {plans.map((p) => <td key={p.id}>{p.user_limit || "Unlimited"}</td>)}
            </tr>
            <tr>
              <td>Free trial</td>
              {plans.map((p) => <td key={p.id}>{p.trial_eligible ? `${p.trial_days} days` : "—"}</td>)}
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
